import { useContext, useState } from 'react'
import { Modal as AntModal } from 'antd'
import { Modal, ModalContext } from './Modal.provider'
import { LoadingOutlined } from '@ant-design/icons'

export function useModal(): Modal {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('Modal Context not available')
  }
  return context
}

export const useLoaderModal = () => {
  const [visible, setVisible] = useState(false)

  const startBlockingLoader = () => {
    setVisible(true)
  }

  const closeBlockingLoader = () => {
    setVisible(false)
  }

  const loader = () => (
    <AntModal
      open={visible}
      closable={false}
      footer={null}
      centered
    >
      <LoadingOutlined spin />
    </AntModal>
  )

  return { startBlockingLoader, closeBlockingLoader, loader }
}
